'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  gap: 1rem;
  min-height: 70px;
  position: sticky;
  top: 0;
  background: white;
  z-index: 60;
  justify-content: space-between;
  @media screen and (width > ${theme.sizes.screens.md}) {
    box-shadow: ${theme.elevation.base};
    padding: 2rem;
  }
`;

export const menu = css`
  min-height: 50px;
  gap: 1.5rem;
  align-items: center;
  display: none;
  @media screen and (width > ${theme.sizes.screens.md}) {
    display: flex;
  }
`;

export const dropdown = css`
  min-width: 200px;
  display: flex;
  flex-direction: column;
`;

export const searchInput = css``;
